/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Reminder_SwitchInputs */

const en_us2_profile_reminder_switch = /** @type {(inputs: Profile_Reminder_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remind me to train`)
};

const pt_br2_profile_reminder_switch = /** @type {(inputs: Profile_Reminder_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lembrar de treinar`)
};

const es_419_profile_reminder_switch = /** @type {(inputs: Profile_Reminder_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recordarme entrenar`)
};

const pt_pt2_profile_reminder_switch = /** @type {(inputs: Profile_Reminder_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lembrar-me de treinar`)
};

const fr_fr2_profile_reminder_switch = /** @type {(inputs: Profile_Reminder_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me rappeler de m'entraîner`)
};

const de_de2_profile_reminder_switch = /** @type {(inputs: Profile_Reminder_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ans Training erinnern`)
};

const it_it2_profile_reminder_switch = /** @type {(inputs: Profile_Reminder_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricordami di allenarmi`)
};

/**
* | output |
* | --- |
* | "Remind me to train" |
*
* @param {Profile_Reminder_SwitchInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_reminder_switch = /** @type {((inputs?: Profile_Reminder_SwitchInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Reminder_SwitchInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_reminder_switch(inputs)
	if (locale === "es-419") return es_419_profile_reminder_switch(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_reminder_switch(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_reminder_switch(inputs)
	if (locale === "de-DE") return de_de2_profile_reminder_switch(inputs)
	if (locale === "it-IT") return it_it2_profile_reminder_switch(inputs)
	return en_us2_profile_reminder_switch(inputs)
});
export { profile_reminder_switch as "profile.reminder_switch" }